import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'src/lib/utils';

// The body wrapper every authenticated page renders below PageHeader — was
// hand-copied (`<div className="p-6 bg-muted min-h-[calc(100vh-3.4rem)]">`)
// into 30+ page files with no max-width, so on large/ultrawide monitors the
// whole page — tables included — stretched edge-to-edge. `max-w-[1400px]`
// reuses the 2xl breakpoint already declared in tailwind.config.js rather
// than inventing a new number. `className` carries whatever each page
// previously appended alongside the shared classes (space-y-*, text-left,
// flex utilities, pb-0, …).
export function PageContainer({ children, className }) {
  return (
    <div
      className={cn(
        'max-w-[1100px] mx-auto p-6 bg-muted min-h-[calc(100vh-3.4rem)]',
        className
      )}
    >
      {children}
    </div>
  );
}

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageContainer.defaultProps = {
  className: '',
};

export default PageContainer;
